export const initialStore = {
  allQueryFormat: [],
  selectedQuery: {},
  portOperation: [],
  fleetList: [],
  selectedVessel: {},
  portDistances: {
    output: {},
    payload: {},
  },
  calculationResult: {},
  pagination: {
    offset: 1,
    limit: 50,
    totalItems: 0,
    totalPages: 0,
  },
  loader: {
    loading: false,
    message: "",
  },
  error: null,
  isOverride: false,
};
